import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import * as online from '../../../appRedux/actions/fuel_request/online'
import ErrorBoundary from '../../../components/error_boundary'
import LoadingList from '../../../components/loading_list'
import * as common from '../../../appRedux/actions/common'
import Marker from '../../../components/map/marker'
import Map from '../../../components/map/mapbox'
import * as constants from '../../../constants'
import BottomContent from './bottom_content'
import config from '../../../util/config'
import TopContent from './top_content'

function FuelRequestOnlineInprocess(props) {
    let { id } = useParams()
    let vRequestCode = id.replace(':id', '')
    let requestDetails = props.field.requestOnline
    let operatorLocation = props.field.operatorLocation

    useEffect(() => {
        requestDetailsFunc()
        const timer = setInterval(() => {
            props.statusFuelRequestAction(vRequestCode)
        }, config.statusFuelRequestOnline)
        return () => clearInterval(timer)

    }, [])

    const requestDetailsFunc = () => {
        props.menuAction(false)
        props.requestDetailsAction(vRequestCode)
    }

    return (
        <React.Fragment>
            <ErrorBoundary>
                {props.loadingPage ? <LoadingList /> : ''}
                <Map
                    {...props}
                >
                    <TopContent />
                    <Marker
                        latitude={requestDetails.location.dLatitude}
                        longitude={requestDetails.location.dLongitude}
                    />
                    <Marker
                        latitude={operatorLocation.dLatitude}
                        longitude={operatorLocation.dLongitude}
                        markerType={constants.MAP_LOCATION_CAR_ONLINE}
                    />
                    <BottomContent
                        requestDetailsFunc={() => requestDetailsFunc()} />
                </Map>
            </ErrorBoundary>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        zoom: 11,
        field: state.field,
        changeViewport: false,
        loadingPage: state.common.loadingPage,
        latitude: state.field.requestOnline.location.dLatitude,
        longitude: state.field.requestOnline.location.dLongitude,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        menuAction: (status) => dispatch(common.menuAction(status)),
        requestDetailsAction: (code) => dispatch(online.requestDetailsAction(code)),
        statusFuelRequestAction: (code) => dispatch(online.statusFuelRequestAction(code))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FuelRequestOnlineInprocess)
